import { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import history from "../history";
import { setPreserveSearch } from "../../Store/SearchReducer/action";

const useNavigation = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    const searchState = useSelector(
        (state) => state.search
    );

    const goBackTo = useCallback(
        (defaultPath, entity = null) => {
            const from = location?.state?.from;

            if (entity) {
                const currentSearchState = searchState?.[entity];

                const isSearchStateEmpty =
                    !currentSearchState ||
                    Object.keys(currentSearchState).length === 0;

                const preserveSearch =
                    !!from && !isSearchStateEmpty;

                dispatch(
                    setPreserveSearch(
                        entity,
                        preserveSearch
                    )
                );
            }

            if (from) {
                history.goBack();
            } else {
                history.push({
                    pathname: defaultPath,
                });
            }
        },
        [location, searchState, dispatch]
    );

    const navigateTo = useCallback(
        (pathname, state = {}, entity = null) => {
            if (entity) {
                dispatch(setPreserveSearch(entity, true));
            }

            history.push({
                pathname,
                state: {
                    from: location.pathname,
                    ...state,
                },
            });
        },
        [location.pathname, dispatch]
    );

    const openInNewTab = useCallback((pathname) => {
        window.open(pathname, "_blank");
    }, []);

    return {
        goBackTo,
        navigateTo,
        openInNewTab,
    };
};

export default useNavigation;